
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    import Patient from '@/types/Patient';
    import Kartei from '@/components/Kartei.vue';
    import PatientenauswertungFilterDialog from '@/components/Statistik/PatientenauswertungFilter.vue';
    import { PatientenauswertungFilter } from '@/store/patientenauswertung';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            PatientenauswertungFilterDialog,
            Kartei,
        },
        computed: {
            ...mapState('patientenauswertung', ['kartei', 'patienten', 'loaders', 'dialogs']),
        },
        methods: {
            ...mapActions('patientenauswertung', [
                'loadPatienten',
                'setDialogs',
                'printFragebogen',
                'openKartei',
                'loadKarteiImpfungen',
            ]),
        },
    })
    export default class Patientenauswertung extends Vue {
        @Prop() public visible!: boolean;

        public loadPatienten!: (payload: { filter: PatientenauswertungFilter }) => void;
        public setDialogs!: (dialogs: { filter?: boolean; kartei?: boolean }) => void;
        public loadKarteiImpfungen!: (payload: { filter: PatientenauswertungFilter }) => void;

        public selected: Patient[] = [];
        public search = '';

        public filter: PatientenauswertungFilter = {
            zeitraum: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
            impfstoffe: [],
            reiseziele: [],
            jahrgang: ['1960', '2000'],
        };

        public get headers(): DataTableHeaders<Patient> {
            return [
                { value: 'nachname', text: 'Nachname' },
                { value: 'vorname', text: 'Vorname' },
                { value: 'Geburtsdatum', text: 'Geburtsdatum' },
                { value: 'alter', text: 'Alter' },
                { text: '', value: 'actions', sortable: false, width: 110 },
            ];
        }

        public get frageboegen(): number[] {
            return this.selected.map((patient: Patient) => patient.patnr as number);
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.loadPatienten({ filter: this.filter });
            }
        }

        public onChangeFilter(): void {
            this.loadPatienten({
                filter: {
                    ...this.filter,
                    zeitraum: this.filter.zeitraum.sort((a: string, b: string) => a.localeCompare(b)),
                },
            });

            this.setDialogs({ filter: false });
        }

        public onChangeKartei(filter: PatientenauswertungFilter): void {
            this.loadKarteiImpfungen({ filter });
        }
    }
